export default __webpack_public_path__ + "static/media/P10.8cce1753.png";